import { z } from 'zod';
import { type JobResponse, jobResponseSchema } from './job-response.schema';
import { isClosedJobStatus } from './job-status.schema';

export const jobStatusEventNameSchema = z.enum(['job.updated', 'job.closed']);
export const jobHeartbeatEventNameSchema = z.literal('job.heartbeat');

export const jobEventNameSchema = z.union([jobStatusEventNameSchema, jobHeartbeatEventNameSchema]);

export const jobStatusEventSchema = z.object({
	type: jobStatusEventNameSchema,
	data: jobResponseSchema,
});

export const jobHeartbeatEventSchema = z.object({
	type: jobHeartbeatEventNameSchema,
	data: z.object({
		jobId: z.uuid(),
	}),
});

export const jobEventSchema = z.discriminatedUnion('type', [jobStatusEventSchema, jobHeartbeatEventSchema]);

export type JobEventName = z.infer<typeof jobEventNameSchema>;
export type JobStatusEvent = z.infer<typeof jobStatusEventSchema>;
export type JobHeartbeatEvent = z.infer<typeof jobHeartbeatEventSchema>;
export type JobEvent = z.infer<typeof jobEventSchema>;

export const toJobEvent = (job: JobResponse): JobStatusEvent => ({
	type: isClosedJobStatus(job.status) ? 'job.closed' : 'job.updated',
	data: job,
});

export const toJobHeartbeatEvent = (jobId: string): JobHeartbeatEvent => ({
	type: 'job.heartbeat',
	data: { jobId },
});
